import type { ItemUnitEntity } from '@/features/item/domain/entities/ItemUnitEntity'
import type { ItemMiniEntity } from '@/features/item/domain/entities/ItemMiniEntity'

export class OrderItemEntity {
  id?: string
  itemId?: number
  itemName?:string
  itemImgUrl?: string
  item?: ItemMiniEntity
  quantity?: number
  itemUnitId?: number | null
  notAvailableUntil?: string | null
  substituteItem?: SubstituteOrderItemEntity
  itemUnit?: ItemUnitEntity
  readonly rawPrice?: number
  readonly overallDiscountAmount?: number
  unitPrice?: number
  selectionAdditionalPrice?: number
  selectionAdditionalPriceDiscountAmount?: number
  discountAmount?: number
  note?: string | null
  selections?: Array<OrderSelectionEntity> | null
  
}

export class SubstituteOrderItemEntity {
  id?: number
  imageUrl?: string | null
  unitPrice?: number
  name?: string | null
}
export class OrderSelectionEntity {
  id?: string
  sectionName?: string | null
  values?: Array<OrderSelectionValueEntity> | null
}

export type OrderSelectionValueEntity = {
  name: string | null
  imageUrl: string | null
  additionalPrice: number | null
  discountAmountPrice: number
  finalAdditionalPrice: number
}
